<app-table [data]="plants"
           [config]="tableConfig"
           title="{{'admin.plants.table.title' | translate}}"
           [rowExpand]="false"
           [rowDuplicate]="true"
           [isMaterial]="false"
           [isLoading]="isLoading"
           [hasTitle]="false"
           [showFilters]="true"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (duplicateClick)="onDuplicate($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.plants.table.columns.plantId' | translate}}"
                      field="id">
    </app-table-column>
    <app-table-column header="{{'admin.plants.table.columns.plantName' | translate}}"
                      filter="true"
                      filterPlaceholder="{{'admin.plants.table.filter.placeholder.name' | translate}}"
                      sortable="true"
                      field="name">
    </app-table-column>
</app-table>
